// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notFoundStyle_wrapper__2Xbjb","heading":"notFoundStyle_heading__10hO9","subheading":"notFoundStyle_subheading__2bJLM","buttonLink":"notFoundStyle_buttonLink__1BQPH"};